import { forwardRef } from 'react';
import * as ReactDialog from '@radix-ui/react-dialog';
import clsx from 'clsx';

import style from './dialog.module.scss';

export const Dialog = ReactDialog.Root;
export const DialogTrigger = ReactDialog.Trigger;
export const DialogPortal = ReactDialog.Portal;
export const DialogClose = ReactDialog.Close;
export const DialogOverlay = ReactDialog.Overlay;

type DialogContentProps = React.ComponentPropsWithoutRef<typeof ReactDialog.Content> & {
  children: React.ReactNode;
  className?: string;
};

export const DialogContent = forwardRef<
  React.ElementRef<typeof ReactDialog.Content>,
  DialogContentProps
>(({ children, className, ...props }, forwardedRef) => (
  <ReactDialog.Content
    className={clsx('legacy-compatible-dialog-content', className, style.DialogContent)}
    {...props}
    ref={forwardedRef}
  >
    {children}
  </ReactDialog.Content>
));
